import { Box, Divider, Typography } from '@material-ui/core'
import MuiAlert from '@material-ui/lab/Alert'
import SectionHeader from '../SectionHeader'
import UploadFileView from '../UploadFileView'
import FilledButton from '../FilledButton'
import history from '../../routes/history'
import { get12HrsFormatValue } from './constants'
import { useStyles } from './styles'

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />
}

const SiteFormView = (props) => {
  const { site } = props
  const classes = useStyles()
  return (
    <div className={classes.layout}>
      <Box className={classes.siteform}>
        <div className={classes.layoutsitedataview}>
          <SectionHeader text="Application Details"></SectionHeader>
          <Box className={classes.formfieldslayoutsitedataview}>
            <Box className={classes.formfieldssitedataview}>
              <Box className={classes.formfieldkeysitedataview}>
                Name of Customer
              </Box>
              <Box className={classes.formfieldvaluesitedataview}>
                {site?.name}
              </Box>
            </Box>
            <Box className={classes.formfieldssitedataview}>
              <Box className={classes.formfieldkeysitedataview}>Address</Box>
              <Box className={classes.formfieldvaluesitedataview}>
                {site?.address}
              </Box>
            </Box>
            <Box className={classes.formfieldssitedataview}>
              <Box className={classes.formfieldkeysitedataview}>
                Phone Number
              </Box>
              <Box className={classes.formfieldvaluesitedataview}>
                {site?.phone_number}
              </Box>
            </Box>
            <Box className={classes.formfieldssitedataview}>
              <Box className={classes.formfieldkeysitedataview}>
                Enphase Site ID
              </Box>
              <Box className={classes.formfieldvaluesitedataview}>
                {site?.site_id}
              </Box>
            </Box>
            <Box className={classes.formfieldssitedataview}>
              <Box className={classes.formfieldkeysitedataview}>
                kW Capacity Committed for dispatch
              </Box>
              <Box className={classes.formfieldvaluesitedataview}>
                {site?.dispatch_capacity}
              </Box>
            </Box>
            <Box className={classes.formfieldssitedataview}>
              {' '}
              <Box className={classes.formfieldkeysitedataview}>
                Dispatch Timings
              </Box>
              <Box className={classes.formfieldvaluesitedataview}>
                {site
                  ? `${get12HrsFormatValue(
                      site?.dispatch_starttime,
                    )} PM to ${get12HrsFormatValue(site?.dispatch_endtime)} PM`
                  : null}
              </Box>
            </Box>
            <Box className={classes.formfieldssitedataview}>
              <Box className={classes.formfieldkeysitedataview}>
                Underlying Program
              </Box>
              <Box className={classes.formfieldvaluesitedataview}>
                {site?.program?.toUpperCase()}
              </Box>
            </Box>
            <Box className={classes.formfieldssitedataview}>
              <Box className={classes.formfieldkeysitedataview}>
                $/kW bucket that was sanctioned
              </Box>
              <Box className={classes.formfieldvaluesitedataview}>
                {site?.rate}
              </Box>
            </Box>
            <Box className={classes.formfieldssitedataview}>
              {' '}
              <Box className={classes.formfieldkeysitedataview}>
                Electric Account Number
              </Box>
              <Box className={classes.formfieldvaluesitedataview}>
                {site?.electric_account_number}
              </Box>
            </Box>
            <Box className={classes.formfieldssitedataview}>
              {' '}
              <Box className={classes.formfieldkeysitedataview}>
                Electric Meter Number
              </Box>
              <Box className={classes.formfieldvaluesitedataview}>
                {site?.electric_meter_number}
              </Box>
            </Box>
          </Box>
        </div>
        <div className={classes.layoutsitefilesview}>
          <>
            <SectionHeader text="Files Uploaded"></SectionHeader>
           <Box className={classes.fileuploadlayoutsitefilesview}>
                {site?.approval_form_key != null && site?.approval_form_presigned_url!=null&&(
                <UploadFileView
                  uploadfiledescription="Application Summary"
                  PDFViewLink={site?.approval_form_presigned_url}
                ></UploadFileView>
              )}
              {site?.tandc_form_key!=null&&site?.tandc_form_presigned_url!=null&&(<UploadFileView
                uploadfiledescription="Scanned copy of the Program T&C Document"
                PDFViewLink={site?.tandc_form_presigned_url}
              ></UploadFileView>)}
              {site?.amendment_form_key!=null&&site?.amendment_form_presigned_url!=null&&(<UploadFileView
                uploadfiledescription="Scanned copy of the EDRP amendment (Optional)"
                PDFViewLink={site?.amendment_form_presigned_url}
              ></UploadFileView>)}
              {site?.agreement_form_key!=null&&site?.agreement_form_presigned_url!=null&&(<UploadFileView
                uploadfiledescription="Scanned copy of the SDP agreement (Optional)"
                PDFViewLink={site?.agreement_form_presigned_url}
              ></UploadFileView>)}
            </Box>
          </>
          {site?.status === 'rejected' && (
            <div className={classes.reason}>
              <SectionHeader text="Reason for Rejection"></SectionHeader>
              <Typography className={classes.reasontext}>
                {site?.reason}
              </Typography>
            </div>
          )}
          {site?.status === 'approved' 
          && site?.report_data?.reportFailureMessage 
          && (
            <div className={classes.reason}>
              <SectionHeader text="Reason for Report Generation Delay"></SectionHeader>
              <Typography className={classes.reasontext}>
                {site?.report_data?.reportFailureMessage}
              </Typography>
            </div>
          )}
        </div>
      </Box>
      <Divider></Divider>
      <Box className={classes.buttons}>
        {' '}
        <FilledButton
          label="Back"
          primary={false}
          width="160px"
          onClick={() => {
            history.push('/installer')
          }}
        ></FilledButton>
      </Box>
    </div>
  )
}
export default SiteFormView
